/* eslint-disable unicorn/consistent-function-scoping */
import Áxios,{ AxiosRequestConfig } from 'axios';
import { v4 as createUUID } from 'uuid';
import FileSaver from 'file-saver';
import moment from 'moment';
import {
  BulkFlashLogActionNames,
  FlashTabStrings,
  ModemFlashRecord,
  PostFlashRecord,
  PreFlashFilters,
  PreFlashRecord,
  SelectedDevice,
  SelectedRowsToWakeup,
  SIMCredentialingRecord,
} from './types';
import FlashLog from '../../services/bulk-device-flash';
import { AppState, AppThunkDispatch } from '..';
import { BulkFlashRequestInput, CompleteUpload, RegisterArguments, PushConfigFilesRequestBody, ShortCommandPostRequest, GetAllCommandsByDeviceKeyRequest, WakeupV2Request, modemOnlyFlashRequset, ScheduleCommandRequest } from '../../services/types';
import { enqueueSnackbarAction } from '../snackbar/actions';
import { statusMapping } from '../../components/bulk-device-management/table/status-mapping';
import {
  csvHeaderString,
  csvHeaderStringOld,
  csvSIMHeaderString,
  postAccessors,
  postHeaderString,
  queueAndFlashSoftwareAccessors,
  queueAndFlashSoftwareHeaderString,
  csvShortMessageHeaderString,
  csvShortCommandHeaderString,
  csvServiceMeterHourString,
  csvConfigFileHeaderString,
  csvDeviceParameter_EOD_String,
  csvDeviceParameter_TamperResistance_String,
  getCsvHeaderString,
  csvSubscription_String,
  csvCommandsInfo,
  csvCommandsInfoAssetNSerailNumber,
  csvDeviceWakeupString,
  csvEngineeringTemplateHeaderString,
  csvModemOnlyFlash,
  csvScheduleCommandHeaderString,
} from '../../components/bulk-device-management/csv-template';
import { QueueFirmwareRequest } from '../../entities/remote-flash-v1/models';
import RemoteFlash from '../../services/remote-flash';
import FileStorage from '../../services/file-storage';
import {
  chunkArray,
  createChunks,
  downloadFromUrl,
  parametersAsObject,
  CSVToArray,
  stringToBlob,
} from '../../globals/utils';
import DeviceWakeUps from '../../services/device-wakeups-v2';
import { WakeupRequest } from '../../entities/device-wake-ups-v2';
import ConfigurationFilesLibrary from '../../services/config-files-library';
import ConfigurationFiles from '../../services/config-files';
import { RemoteFlashActionNames } from '../configure/remote-flash/types';
import Campaign from '../../services/campaign';
import Devices from '../../services/devices';
import { BootstrapType, ConfigType, DeviceParameterConfigType, SIMCredentialing } from '../../pages/bulk-device-management/types';
import { ShortMessagePostRequest } from '../../entities/short-message-request-configuration-v1/models';
import ShortMessageRequestConfiguration from '../../services/short-message-request-configuration';
import { MeterValueAdjustmentRequest } from '../../entities/meter-value-adjustment-config/models';
import MeterValueAdjustmentConfig from '../../services/meter-value-adjustment-config';
import ShortCommand from '../../services/short-commands';
import ShortCommandV2 from '../../services/short-command-v2';
import { AssetDeviceConfigRequest } from '../../entities/asset-device-config-v2/asset-device-config-request';
import AssetDeviceConfiguration from '../../services/asset-device-configuration';
import { SubscriptionConfigRequest } from '../../entities/subscription-config-v2/subscription-config-request';
import SubscriptionConfigurationV2 from '../../services/subscription-config-v2';
import { DeviceByMakeAndSerialBulkGetRequest } from '../../entities/homing-v2/device-by-serail-and-asset-number';
import { DeviceByMakeSerialAndDeviceCharBulkGetRequest } from '../../entities/homing-v2/device-by-serial-asset-device-char';
import Homing from '../../services/homing';
import { getCommandsFromMultipleDevices } from '../commands/actions';

const unSupportedFileTypeIds = new Set(["10085", "10531", "10487", "12021", "10160", "10183", "10202", "10490", "10173",
  "10077", "10671", "10318", "10368", "10036", "10475", "10350", "10078", "10530", "12021", "10159", "12021", "10323"]);

export const setCsvDevicesToUpload = (csv: string) => async (dispatch: AppThunkDispatch) => {
  dispatch({
    type: BulkFlashLogActionNames.SET_CSV_TO_UPLOAD,
    payload: csv,
  });
};

export const formatDeviceList = (deviceList: FormatDevice[]) =>
  deviceList.map(
    (device) => `\n${device.make},${device.equipmentSN || device.serialNumber},${device.deviceId}`,
  );

export const downloadErrorLog =
  (errorDownloadId: string) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const storage = new FileStorage(client, envVariables.storageV1BaseUrl);
    const response: any = await storage.retrieveMetaDataById(errorDownloadId);
    if (response.status === 200) {
      downloadFromUrl(response.data.downloadUrl);
      dispatch(
        enqueueSnackbarAction({
          message: 'Downloaded',
          options: { key: (Date.now() + Math.random()).toString(), variant: 'success' },
        }),
      );
    } else {
      dispatch(
        enqueueSnackbarAction({
          message: 'Download Failed please try again',
          options: { key: (Date.now() + Math.random()).toString(), variant: 'error' },
        }),
      );
    }
  };

export const preFlashLogs =
  ({ file, deviceKey }: { file?: string; deviceKey?: string }) =>
    async (dispatch: AppThunkDispatch, getState: () => AppState) => {
      const {
        login: { client, envVariables },
        bulkFlash: { csvDevicesToUpload, errorFileDownloadIds },
      } = getState();
      const flashLog = new FlashLog(client, envVariables.flashLogsV1);
      const body = file || csvDevicesToUpload;
      const input: BulkFlashRequestInput = { body, deviceKey };
      dispatch({
        type: BulkFlashLogActionNames.SET_LOADING,
        payload: true,
      });
      dispatch({
        type: BulkFlashLogActionNames.SET_ERROR_LOG_DOWNLOAD_ID,
        payload: {
          preFlash: undefined,
          postFlash: errorFileDownloadIds.postFlash,
        },
      });
      if (body)
        try {
          const response = await flashLog.preFlash(input);
          const logs = response.data.preFlashLogs;
          const successfulLogs = logs.filter(
            (preLog: PreFlashRecord) => preLog.description === 'Success',
          );
          const bodyLogs = body
            .trim()
            .split(/\r?\n/)
            .map((line) => line.split(',').map((word) => word.trim()));
          const failedLogs = logs
            .filter((preLog: PreFlashRecord) => preLog.description !== 'Success')
            .filter((preLog: PreFlashRecord) =>
              bodyLogs.find((bodyLog) => bodyLog[2] === preLog.deviceId),
            );

          if (failedLogs.length > 0) {
            dispatch(
              enqueueSnackbarAction({
                message: `${failedLogs.length} devices returned errors`,
                options: {
                  variant: 'error',
                  downloadAction: () => {
                    dispatch(downloadErrorLog(response.data.bulkDetails.failedDevicesDownloadId));
                  },
                },
              }),
            );
          }
          if (file) {
            dispatch(setCsvDevicesToUpload(formatDeviceList(successfulLogs).join('')));
          }
          dispatch({
            type: BulkFlashLogActionNames.SET_PRE_FLASH_LOG,
            payload: successfulLogs,
          });
          dispatch({
            type: BulkFlashLogActionNames.SET_BATCH_ID,
            payload: response.data.bulkDetails.batchId,
          });
          dispatch({
            type: BulkFlashLogActionNames.SET_TOTAL_ACCEPTED_DEVICES,
            payload: response.data.totalAcceptedDevices,
          });
          dispatch({
            type: BulkFlashLogActionNames.SET_ERROR_LOG_DOWNLOAD_ID,
            payload: {
              preFlash: response.data.bulkDetails.failedDevicesDownloadId,
              postFlash: errorFileDownloadIds.postFlash,
            },
          });
          if (successfulLogs.length > 0) {
            dispatch(
              enqueueSnackbarAction({
                message: 'Pre Flash Processed Successfully',
                options: { variant: 'success' },
              }),
            );
          } else if (failedLogs.length === 0 && successfulLogs.length === 0) {
            dispatch(
              enqueueSnackbarAction({
                message: 'Upload failed. Please try with different devices',
                options: { variant: 'error' },
              }),
            );
          }
        } catch (error: any) {
          if (error?.response?.status === 400) {
            dispatch(
              enqueueSnackbarAction({
                message: `${error.message}`,
                options: {
                  variant: 'error',
                },
              }),
            );
          } else {
            dispatch(
              enqueueSnackbarAction({
                message: 'Upload failed. Please try again',
                options: { variant: 'error' },
              }),
            );
          }
        }
      dispatch({
        type: BulkFlashLogActionNames.SET_LOADING,
        payload: false,
      });
    };
export const campaignLogs = () => async (dispatch: AppThunkDispatch) => {
  dispatch({
    type: BulkFlashLogActionNames.SET_LOG_TAB,
    payload: FlashTabStrings.campaign,
  });
};

export const postFlashLogs =
  ({ devices, deviceKey }: { devices?: string; deviceKey?: string }) =>
    async (dispatch: AppThunkDispatch, getState: () => AppState) => {
      const {
        login: { client, envVariables },
        bulkFlash: { batchId, csvDevicesToUpload, errorFileDownloadIds },
      } = getState();
      dispatch({
        type: BulkFlashLogActionNames.SET_LOADING,
        payload: true,
      });
      dispatch({
        type: BulkFlashLogActionNames.SET_ERROR_LOG_DOWNLOAD_ID,
        payload: { preFlash: errorFileDownloadIds.preFlash, postFlash: undefined },
      });
      dispatch({
        type: BulkFlashLogActionNames.SET_LOG_TAB,
        payload: FlashTabStrings.postFlash,
      });
      if (devices || csvDevicesToUpload)
        try {
          const flashLog = new FlashLog(client, envVariables.flashLogsV1);
          const input: BulkFlashRequestInput = {
            body: devices || csvDevicesToUpload,
            deviceKey,
            batchId,
          };
          const response = await flashLog.postFlash(input);
          const postFlashResponse = response.data.postFlashLogs;
          const successfulLogs = postFlashResponse.filter(
            (postLog: PostFlashRecord) => postLog.description === 'Success',
          );
          const logsAppendedColumns = successfulLogs.map((postLog: PostFlashRecord) => {
            const statusAttributes: { [key: string]: string } = {};
            if (postLog.statuses) {
              // ascending sort that will put the most recent dates at the end of the array
              postLog.statuses.sort((a, b) => (a.flashStatusTime > b.flashStatusTime ? 1 : -1));
              postLog.statuses.forEach((status) => {
                const instanceMapped = statusMapping[status.flashStatus];
                if (instanceMapped)
                  statusAttributes[
                    instanceMapped?.columnAccessor
                  ] = `${instanceMapped?.message} ${status.flashStatusTime}`;
              });
              if (statusAttributes !== {}) return { ...postLog, ...statusAttributes };
            }
            return postLog;
          });
          if (postFlashResponse.length > 0 && logsAppendedColumns.length === 0)
            dispatch(
              enqueueSnackbarAction({
                message: 'No flashed devices',
                options: {
                  variant: 'error',
                },
              }),
            );
          else {
            dispatch({
              type: BulkFlashLogActionNames.SET_POST_FLASH_LOG,
              payload: logsAppendedColumns,
            });
            dispatch({
              type: BulkFlashLogActionNames.SET_BATCH_ID,
              payload: response.data.bulkDetails.batchId,
            });
            dispatch({
              type: BulkFlashLogActionNames.SET_ERROR_LOG_DOWNLOAD_ID,
              payload: {
                preFlash: errorFileDownloadIds.preFlash,
                postFlash: response.data.bulkDetails.failedDevicesDownloadId,
              },
            });
          }
        } catch (error: any) {
          dispatch(
            enqueueSnackbarAction({
              message: error.message,
              options: { variant: 'error' },
            }),
          );
        }
      dispatch({
        type: BulkFlashLogActionNames.SET_LOADING,
        payload: false,
      });
    };

export const setLogTab =
  (
    tabToSet:
      | FlashTabStrings.preFlash
      | FlashTabStrings.postFlash
      | FlashTabStrings.campaign
      | FlashTabStrings.simCredentialing
      | FlashTabStrings.configAdmin,
  ) =>
    async (dispatch: AppThunkDispatch, getState: () => AppState) => {
      const {
        bulkFlash: { logTab },
      } = getState();
      if (logTab !== tabToSet)
        dispatch({
          type: BulkFlashLogActionNames.SET_LOG_TAB,
          payload: tabToSet,
        });
    };

export type FormatDevice = {
  make: string | null;
  equipmentSN?: string | null;
  serialNumber?: string | null;
  deviceId: string | null;
};

const readFileAsync = (file: File, callback: Function) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', (event) => {
      callback(event?.target?.result);
      resolve(reader.result);
    });
    reader.addEventListener('error', reject);
    reader.readAsText(file);
  });

export const uploadBlendedFromCsv =
  (file: any) => (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      bulkFlash: { csvDevicesToUpload, manualDevicesToUpload },
    } = getState();
    return readFileAsync(file, (contents: string) => {
      if (file.name.includes('.csv')) {
        let deviceListCsv = contents.replace(csvHeaderString, '').replace(csvHeaderStringOld, '');
        if (csvDevicesToUpload) deviceListCsv = `${csvDevicesToUpload}${deviceListCsv}`;
        if (manualDevicesToUpload)
          deviceListCsv = `${formatDeviceList(manualDevicesToUpload).join('')}${deviceListCsv}`;
        if (typeof deviceListCsv === 'string') {
          dispatch(preFlashLogs({ file: deviceListCsv }));
        }
      } else {
        dispatch(
          enqueueSnackbarAction({
            message: 'Must be a csv file',
            options: { variant: 'error' },
          }),
        );
      }
    });
  };

export const getSimRecredentialStatus =
  () => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
      search: { selectedEntity },
    } = getState();
    const flashLog = new FlashLog(client, envVariables.deviceWakeUpsV2);
    const input = {
      deviceKey: selectedEntity?.deviceKey,
      telematicAssetId: selectedEntity?.telematicsAssetId,
      make: selectedEntity?.assetMake,
      serialNumber: selectedEntity?.assetSerialNumber,
      deviceType: selectedEntity?.deviceType,
      deviceId: selectedEntity?.deviceId,
    };
    return flashLog.getSimRecredentialStatus(input);
  };

export const refreshSimRecredentialStatus =
  (actionType: string) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
      bulkFlash: { simCredentialing },
    } = getState();
    const flashLog = new FlashLog(client, envVariables.deviceWakeUpsV2);
    if (simCredentialing?.length) {
      const deviceRows = await Promise.all(
        simCredentialing.map((row) => {
          const { make, serialNumber } = row;
          const input = {
            make,
            serialNumber,
          };
          return flashLog.getSimRecredentialStatus(input);
        }),
      );
      const result = deviceRows.map((row, index) => {
        if (!row?.data?.devices.length) {
          return {
            make: simCredentialing[index].make,
            serialNumber: simCredentialing[index].serialNumber,
            country: simCredentialing[index].country,
            lmno: simCredentialing[index].lmno,
          };
        }
        return row.data.devices[0];
      });
      dispatch({
        type: BulkFlashLogActionNames.SET_SIM_CREDENTIALING,
        payload: result,
      });
      dispatch(
        enqueueSnackbarAction({
          message: `${actionType} Status Refreshed`,
          options: {
            variant: 'success',
          },
        }),
      );
    }
  };

export const uploadSIMCSV =
  (file: any, actionType: string, bootstrapActionType: string) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    let filetext = await file.text();
    const result: SIMCredentialingRecord[] = [];
    const MAX_ROWS = (actionType===SIMCredentialing.EngineeringTemplate) ? 1000 : 25;
    let fileBlob = stringToBlob(filetext, 'text/csv');
    if (!(file?.name.includes('.csv') && fileBlob instanceof Blob)) {
      dispatch(
        enqueueSnackbarAction({
          message: 'Must be a csv file',
          options: { variant: 'error' },
        }),
      );
      return null;
    }
    const delimiter = '\r\n';
    let rawRows = CSVToArray(filetext, delimiter);
    const rowsWithheader = rawRows.filter((row) => !!row.trim())?.filter((row) => !row.startsWith(','));
    const deviceListCsv = "";
    switch (actionType) {
      case SIMCredentialing.SimCredential: {
        if ((rowsWithheader.length === 0) || !((rowsWithheader[0] === getCsvHeaderString(SIMCredentialing.SimCredential)))) {
          dispatch(
            enqueueSnackbarAction({
              message: `The CSV file must be valid to Sim Credentialing`,
              options: { variant: 'error' },
            }),
          );
          return null;
        }
        break;
      }
      case SIMCredentialing.EngineeringTemplate: {
        if ((rowsWithheader.length === 0) || !((rowsWithheader[0] === getCsvHeaderString(SIMCredentialing.EngineeringTemplate)))) {
          dispatch(
            enqueueSnackbarAction({
              message: `The CSV file must be valid to Engineering Template`,
              options: { variant: 'error' },
            }),
          );
          return null;
        }
        break;
      }
      default:
    }
    rowsWithheader.shift();
    const rows = rowsWithheader;
    if (rows.length === 0) {
      dispatch(
        enqueueSnackbarAction({
          message: `The CSV file must have minimum 1 row`,
          options: { variant: 'error' },
        }),
      );
      return null;
    }
    if (rows.length > MAX_ROWS) {
      dispatch(
        enqueueSnackbarAction({
          message: `The CSV file must have maximum ${MAX_ROWS} rows`,
          options: { variant: 'error' },
        }),
      );
      return null;
    }
    if (SIMCredentialing.EngineeringTemplate) {
      let mapRows: any = rawRows;
      rawRows.shift();
      mapRows = rawRows.map((row) => {
        const newRow = row.split(',');
        newRow.splice(6, 0, bootstrapActionType);
        const modifiedRow = newRow.toString();
        return modifiedRow;
      }
      );
      mapRows.splice(-1);
      const finalArray = ["Asset Make,Asset Serial Number,Country,LMNO,Enable Profile,EID,Bootstrap"].concat(mapRows);
      rawRows = finalArray;
      const rowsWithBootstrap = finalArray.join("\n");
      filetext = rowsWithBootstrap;
      fileBlob = stringToBlob(filetext, 'text/csv');
    }
    dispatch({
      type: BulkFlashLogActionNames.SET_SIM_CREDENTIALING_FILE,
      payload: file,
    });
    const flashLog = new FlashLog(client, envVariables.deviceWakeUpsV2);
    const formData = new FormData();
    formData.append('file', fileBlob, file.name);
    formData.append(
      'metadata',
      JSON.stringify({
        applicationId: 'iot-gateway',
      }),
    );
    await flashLog.uploadSIMCredentialingCSV(formData, bootstrapActionType);
    const responses = async () => {
      try {
        return await flashLog.uploadEngineeringTemplateCSV(formData);
      } catch (error: any) {
        return error?.response;
      }
    }
    const devicesArray = await responses();
    const deviceRows: any[] = devicesArray?.data?.devices || [];
    if (deviceRows.length === 0) {
      dispatch(
        enqueueSnackbarAction({
          message: devicesArray?.data?.description,
          options: {
            variant: 'error',
          },
        }),
      )
    } else {
      dispatch({
        type: BulkFlashLogActionNames.SET_SIM_CREDENTIALING,
        payload: deviceRows,
      });
      dispatch(
        enqueueSnackbarAction({
          message: `${file.name} Uploaded`,
          options: {
            variant: 'success',
          },
        }),
      );
    }
    return deviceRows;
  };

export const uploadFileToGetStatus =
  (file: any, actionType: string, bootstrapActionType: string) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    let filetext = await file.text();
    const result: SIMCredentialingRecord[] = [];
    const MAX_ROWS = (actionType===SIMCredentialing.EngineeringTemplate) ? 1000 : 25;
    let fileBlob = stringToBlob(filetext, 'text/csv');
    if (!(file?.name.includes('.csv') && fileBlob instanceof Blob)) {
      dispatch(
        enqueueSnackbarAction({
          message: 'Must be a csv file',
          options: { variant: 'error' },
        }),
      );
      return null;
    }
    const delimiter = '\r\n';
    let rawRows = CSVToArray(filetext, delimiter);
    const rowsWithheader = rawRows.filter((row) => !!row.trim())?.filter((row) => !row.startsWith(','));
    switch (actionType) {
      case SIMCredentialing.SimCredential: {
        if ((rowsWithheader.length === 0) || !((rowsWithheader[0] === getCsvHeaderString(SIMCredentialing.SimCredential)))) {
          dispatch(
            enqueueSnackbarAction({
              message: `The CSV file must be valid to Sim Credentialing`,
              options: { variant: 'error' },
            }),
          );
          return null;
        }
        break;
      }
      case SIMCredentialing.EngineeringTemplate: {
        if ((rowsWithheader.length === 0) || !((rowsWithheader[0] === getCsvHeaderString(SIMCredentialing.EngineeringTemplate)))) {
          dispatch(
            enqueueSnackbarAction({
              message: `The CSV file must be valid to Engineering Template`,
              options: { variant: 'error' },
            }),
          );
          return null;
        }
        break;
      }
      default:
    }
    rowsWithheader.shift();
    const rows = rowsWithheader;
    if (rows.length === 0) {
      dispatch(
        enqueueSnackbarAction({
          message: `The CSV file must have minimum 1 row`,
          options: { variant: 'error' },
        }),
      );
      return null;
    }
    if (rows.length > MAX_ROWS) {
      dispatch(
        enqueueSnackbarAction({
          message: `The CSV file must have maximum ${MAX_ROWS} rows`,
          options: { variant: 'error' },
        }),
      );
      return null;
    }
    dispatch({
      type: BulkFlashLogActionNames.SET_SIM_CREDENTIALING_FILE,
      payload: file,
    });
    if (SIMCredentialing.EngineeringTemplate) {
      let mapRows: any = rawRows;
      rawRows.shift();
      mapRows = rawRows.map((row) => {
        const newRow = row.split(',');
        newRow.splice(6, 0, bootstrapActionType);
        const modifiedRow = newRow.toString();
        return modifiedRow;
      }
      );
      mapRows.splice(-1);
      const finalArray = ["Asset Make,Asset Serial Number,Country,LMNO,Enable Profile,EID,Bootstrap"].concat(mapRows);
      rawRows = finalArray;
      const rowsWithBootstrap = finalArray.join("\n");
      filetext = rowsWithBootstrap;
      fileBlob = stringToBlob(filetext, 'text/csv');
    }
    const flashLog = new FlashLog(client, envVariables.deviceWakeUpsV2);
    const formData = new FormData();
    formData.append('file', fileBlob, file.name);
    formData.append(
      'metadata',
      JSON.stringify({
        applicationId: 'iot-gateway',
      }),
    );
    const responses = async () => {
      try {
        return await flashLog.uploadEngineeringTemplateCSV(formData);
      } catch (error: any) {
        return error?.response;
      }
    }
    const devicesArray = await responses();
    const deviceRows: any[] = devicesArray?.data?.devices || [];
    if (deviceRows.length === 0) {
      dispatch(
        enqueueSnackbarAction({
          message: devicesArray?.data?.description,
          options: {
            variant: 'error',
          },
        }),
      )
    } else {
      dispatch({
        type: BulkFlashLogActionNames.SET_SIM_CREDENTIALING,
        payload: deviceRows,
      });
      dispatch(
        enqueueSnackbarAction({
          message: `${file.name} Uploaded`,
          options: {
            variant: 'success',
          },
        }),
      );
    }
    return deviceRows;
  };

const displaySuccessMessage = (actionName: string, uniqueKey: string, dispatch: AppThunkDispatch) => {
  dispatch(
    enqueueSnackbarAction({
      message: `Bulk ${actionName} Action is Successful`,
      options: { variant: 'success', persist: true, key: uniqueKey },
    }),
  );
}

const displayErrorMessage = (error: string, uniqueKey: string, dispatch: AppThunkDispatch) => {
  dispatch(
    enqueueSnackbarAction({
      message: `Command queuing failed for batch of : ${error}`,
      options: { variant: 'error', key: uniqueKey },
    }),
  );
}

export const shortMessageRequestConfigAction =
  (input: ShortMessagePostRequest) =>
    async (dispatch: AppThunkDispatch, getState: () => AppState) => {
      const {
        login: { client, envVariables },
      } = getState();
      const shortMessageRequestConfiguration = new ShortMessageRequestConfiguration(
        client,
        envVariables.shortMessageRequestConfigurationV1BaseUrl,
      );
      const classificationType = { classification: 'PLMessage' };
      let errorList: any[] = [];
      try {
        const response = await shortMessageRequestConfiguration.queueShortMessageForAssetOrDevice(
          input,
          classificationType,
        );
        if (response.status === 200) {
          errorList = response?.data?.configs.filter(item => item.code !== '200');
          if (errorList.length === 0) {
            const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Success`;
            displaySuccessMessage('Short Message', uniqueKey, dispatch);
            return [];
          }
        }
        return errorList;

      } catch (error: any) {
        errorList = input.configs.map(config => ({ ...config, description: error.message }));
        const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Error`;
        displayErrorMessage(error.toString(), uniqueKey, dispatch);
      }
      console.log(`Error list returned when response is not 200 :  ${JSON.stringify(errorList)}`);
      return errorList;
    };

export const shortCommandAction = (input: ShortCommandPostRequest, inValidInputs?: any[] | undefined) =>
  async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const shortCommand = new ShortCommand(client, envVariables.shortCommandsV1BaseUrl);
    let errorList: any[] = [];
    try {
      const response = await shortCommand.queueShortCommandForAssetOrDevice(input);

      if (response.status === 200) {
        errorList = response?.data?.configs.filter(item => item.code !== '200');
        if (errorList.length === 0 && inValidInputs && inValidInputs.length === 0) {
          const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Success`;
          displaySuccessMessage('Short Command', uniqueKey, dispatch);
          return [];
        }
        return errorList;
      }
    } catch (error: any) {
      errorList = input.configs.map(config => ({ ...config, description: error.message }));
      const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Error`;
      displayErrorMessage(error.toString(), uniqueKey, dispatch);
    }
    return errorList;
  };

export const deviceWakeupsConfigAction = (input: WakeupRequest) =>
  async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const deviceWakeUps = new DeviceWakeUps(client, envVariables.deviceWakeUpsV2);
    let errorList: any[] = [];
    try {
      const response = await deviceWakeUps.wakeupDevices(input, false);
      if (response.status === 200) {
        errorList = response?.data?.devices.filter((item: { code: string; }) => item.code !== '200');
        if (errorList.length === 0) {
          const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Success`;
          return [];
        }
        return errorList;
      }
    } catch (error: any) {
      errorList = input.devices.map((device: any) => ({ ...device, description: error.message }));
      const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Error`;
      if (!error.message.includes('404')) {
        displayErrorMessage(error.toString(), uniqueKey, dispatch);
      }
    }
    return errorList;
  };

interface InvalidCommandConfig {
  code?: string;
  description?: string;
  [key: string]: any;
}
export const ScheduleCommandAction = (input: ScheduleCommandRequest) =>
  async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const ScheduleCommand = new ShortCommandV2(client, envVariables.shortCommandsV2BaseUrl);
    let errorList: any[] = [];
    try {
      const response = await ScheduleCommand.queueScheduleCommand(input);

      if (response.status === 200) {
          errorList = response?.data?.configs.filter((item: { code: string; }) => item.code !== '200' && item.code !== '201');
          if (errorList.length === 0) {
          const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Success`;
          displaySuccessMessage('Schedule Command', uniqueKey, dispatch);
          return [];
        }
        return errorList;
      }
    } catch (error: any) {
      errorList = input.configs.map((config: any) => ({ ...config, description: error.message }));
      const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Error`;
      displayErrorMessage(error.toString(), uniqueKey, dispatch);
    }
    return errorList;
  };
const serviceMeterHourRequestConfigAction =
  (input: MeterValueAdjustmentRequest) =>
    async (dispatch: AppThunkDispatch, getState: () => AppState) => {
      const {
        login: { client, envVariables },
      } = getState();
      const serviceMeterHourRequestConfiguration = new MeterValueAdjustmentConfig(
        client,
        envVariables.meterValueConfigurationV2BaseUrl,
      );
      try {
        const response = await serviceMeterHourRequestConfiguration.meterValueAdjustmentByDevice(
          input
        );
        if (response.status === 200) {
          let errorList: Array<any> = response?.data?.configs.filter(item => item.code !== '200');
          errorList = errorList.map(item => ({
            ...item,
            hoursAdjusted: item.serviceMeterHourAdjustment.hoursAdjusted,
          }));
          if (errorList.length === 0) {
            const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Success`;
            displaySuccessMessage('Service Meter Hour Adjustment', uniqueKey, dispatch);
            return null;
          }
          return errorList;
        }
      } catch (error: any) {
        const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Error`;
        displayErrorMessage(error.toString(), uniqueKey, dispatch);
      }
      return null;
    };

export const configFileRequestAction = (input: PushConfigFilesRequestBody) =>
  async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const configFile = new ConfigurationFiles(
      client,
      envVariables.configurationFilesV1BaseUrl,
    );
    let errorList: any[] = [];
    try {
      const response = await configFile.pushConfigFiles(
        input,
      );
      if (response.status === 200) {
        errorList = response?.data?.configs.filter((item: { code: string; }) => item.code !== '200');
        if (errorList.length === 0) {
          const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Success`;
          displaySuccessMessage('Config Files', uniqueKey, dispatch);
          return [];
        }
        return errorList;
      }
    } catch (error: any) {
      errorList = input.configs.map(config => ({ ...config, description: error.message }));
      const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Error`;
      displayErrorMessage(error.toString(), uniqueKey, dispatch);
    }
    return errorList;
  }

const assetDeviceV2RequestAction = (input: AssetDeviceConfigRequest, parameterType: string) =>
  async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const assetDeviceService = new AssetDeviceConfiguration(
      client,
      envVariables.assetDeviceConfigV2BaseUrl,
    );
    let errorList: any[] = [];
    try {
      const response = await assetDeviceService.queueAssetDeviceConfiguration(
        input,
      );
      if (response.status === 200) {
        errorList = response?.data?.configs.filter(item => item.code !== '200');
        if (parameterType === DeviceParameterConfigType.EOD) {
          errorList = errorList.map(item => ({
            ...item,
            endOfDay: item.endofDayReportTime.endOfDay,
          }));
          if (errorList.length === 0) {
            const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Success`;
            displaySuccessMessage('End Of Day Report Config', uniqueKey, dispatch);
            return [];
          }
        } else {
          errorList = errorList.map(item => ({
            ...item,
            machineStartMode: item.disableDerate.disableDerateStartMode.machineStartMode,
            tamperResistance: item.disableDerate.disableDerateTamperResistance.tamperResistance,
          }));
          if (errorList.length === 0) {
            const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Success`;
            displaySuccessMessage('Tamper Resistance Config', uniqueKey, dispatch);
            return [];
          }
        }
        return errorList;
      }
    } catch (error: any) {
      errorList = input.configs.map(config => ({ ...config, description: error.message }));
      const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Error`;
      displayErrorMessage(error.toString(), uniqueKey, dispatch);
    }
    return errorList;
  }

const subscriptionConfigV2RequestAction = (input: SubscriptionConfigRequest) =>
  async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const subscriptionV2Service = new SubscriptionConfigurationV2(
      client,
      envVariables.subscriptionConfigV2BaseUrl,
    );
    try {
      const response = await subscriptionV2Service.queueSubscriptionConfiguration(
        input,
      );
      if (response.status === 200) {
        let errorList: Array<any> = response?.data?.configs.filter((item: { code: string; }) => item.code !== '200');
        errorList = errorList.map(item => ({
          ...item,
          subscriptionId: item.subscription.subscriptionId,
        }));
        if (errorList.length === 0) {
          const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Success`;
          displaySuccessMessage('Subscription Config', uniqueKey, dispatch);
          return null;
        }
        return errorList;
      }
    } catch (error: any) {
      const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Error`;
      displayErrorMessage(error.toString(), uniqueKey, dispatch);
    }
    return null;
  }

function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const generateErrorReport = async (payload: Array<any>, errorList: Array<any>, expectKeys: Array<string>, csvHeader: Array<string>, fileName: string, dispatch: AppThunkDispatch) => {
  const solidError: Array<string> = [];
  errorList.forEach((error) => {
    const errorRow: Array<string> = [];
    expectKeys.forEach((key) => {
      if (error[key]) {
        errorRow.push(error[key]);
      } else {
        const currentRecord = payload.find(item => item.transactionId === error.transactionId);
        if (currentRecord) {
          errorRow.push(currentRecord[key]);
        } else {
          errorRow.push(' ');
        }
      }
    });
    solidError.push(`${errorRow.join(',')}`);
  });
  const blob = new Blob(
    [`${csvHeader.concat('Description').join(',')}\n${solidError.join('\n')}`],
    {
      type: 'text/plain;charset=utf-8',
    },
  );
  await FileSaver.saveAs(blob, `Failed_${fileName}_Queue_Log_${moment().format('MMMM_Do_YYYY_h:mm:ss_a')}.csv`);
  await delay(500);
  dispatch(
    enqueueSnackbarAction({
      message: 'Downloaded',
      options: { key: (Date.now() + Math.random()).toString(), variant: 'success' },
    }),
  );
}

const dispatchPopupWithErrorList = (payload: any, errorList: any[], actionType: string, expectKeys: string[], csvHeader: string[], dispatch: AppThunkDispatch) => {
  dispatch(
    enqueueSnackbarAction({
      message: `${errorList.length} devices returned errors`,
      options: {
        variant: 'error',
        persist: true,
        downloadAction: () => {
          generateErrorReport(payload?.configs, errorList, expectKeys, csvHeader, actionType, dispatch);
        },
      },
    }),
  );
}

const sliceIntoChunks = (array: any[], chunkSize: number) => {
  const response = [];
  for (let index = 0; index < array.length; index += chunkSize) {
    const chunk = array.slice(index, index + chunkSize);
    response.push(chunk);
  }
  return response;
}

const processAndGetCombinedError = async (configs: any[], callback: Function, parameterType: string | any, dispatch: AppThunkDispatch, headerElement?: any[], actionType?: string | undefined) => {
  const batchedInput: any[][] = sliceIntoChunks(configs, 25);
  let combinedErrorList: any[] = [];
  const promises: Promise<any[] | null>[] = [];
  let inValidInputs: any[] = [];

  if (parameterType === DeviceParameterConfigType.EOD || parameterType === DeviceParameterConfigType.TamperResistance) {
    /* eslint-disable no-restricted-syntax */
    for (const batch of batchedInput) {
      /* eslint-disable promise/always-return */
      /* eslint-disable no-await-in-loop */
      const promise: any = await new Promise((resolve, reject) => {
        dispatch(callback({ "configs": batch, wakeup: true }, parameterType))
          .then((data: any) => {
            resolve(data);
          })
          .catch((error: any) => {
            reject(error);
          });
      });
      promises.push(promise);
    }
  } else if (parameterType === "fetchCommand") {
    /* eslint-disable no-restricted-syntax */
    for (const batch of batchedInput) {
      /* eslint-disable promise/always-return */
      /* eslint-disable no-await-in-loop */
      const promise: any = await new Promise((resolve, reject) => {
        dispatch(callback(batch, headerElement))
          .then((data: any) => {
            resolve(data);
          })
          .catch((error: any) => {
            reject(error);
          });
      });
      promises.push(promise);
    }
  } else if (parameterType === "device wakeups") {
    /* eslint-disable no-restricted-syntax */
    for (const batch of batchedInput) {
      /* eslint-disable promise/always-return */
      /* eslint-disable no-await-in-loop */
      const promise: any = await new Promise((resolve, reject) => {
        dispatch(callback({ "devices": batch, wakeupType: "all" }))
          .then((data: any) => {
            resolve(data);
          })
          .catch((error: any) => {
            reject(error);
          });
      });
      promises.push(promise);
    }
  } else if (actionType === 'short command') {
    const validInputs = configs.filter(item => !unSupportedFileTypeIds.has(item.fileTypeId));
    const batchedInput: any[][] = sliceIntoChunks(validInputs, 25);
    /* eslint-disable no-restricted-syntax */
    /*  eslint no-loop-func: "error"  */
    inValidInputs = configs.filter(item => unSupportedFileTypeIds.has(item.fileTypeId));
    inValidInputs = inValidInputs.map((item) => ({ ...item, description: "Unsupported Filetype Id" }));

    for (const batch of batchedInput) {
      /* eslint-disable promise/always-return */
      /* eslint-disable no-await-in-loop */
      const promise: any = await new Promise((resolve, reject) => {
        dispatch(callback({ "configs": batch, wakeup: true }, inValidInputs))
          .then((data: any) => {
            resolve(data);
          })
          .catch((error: any) => {
            reject(error);
          });
      });
      promises.push(promise);
    }
  } else if (actionType === 'schedule command') {
    /* eslint-disable no-restricted-syntax */
    for (const batch of batchedInput) {
      /* eslint-disable promise/always-return */
      /* eslint-disable no-await-in-loop */
      const promise: any = await new Promise((resolve, reject) => {
        dispatch(callback({ 'configs': batch }))
          .then((data: any) => {
            resolve(data);
          })
          .catch((error: any) => {
            reject(error);
          });
      });
      promises.push(promise);
    }

  } else {
    /* eslint-disable no-restricted-syntax */
    for (const batch of batchedInput) {
      /* eslint-disable promise/always-return */
      /* eslint-disable no-await-in-loop */
      const promise: any = await new Promise((resolve, reject) => {
        dispatch(callback({ "configs": batch }))
          .then((data: any) => {
            resolve(data);
          })
          .catch((error: any) => {
            reject(error);
          });
      });
      promises.push(promise);
    }

  }
  const responses = await Promise.allSettled(promises);
  const filteredResponses = responses.map(response => response.status === 'fulfilled' ? response.value : []).filter(x => x?.length !== 0);
  filteredResponses.forEach(response => { combinedErrorList = combinedErrorList.concat(response) });
  return combinedErrorList.concat(inValidInputs);
}

const processFireAndForget = async (rows: string[], actionType: string, parameterType: string, dispatch: AppThunkDispatch,getState: () => AppState) => {
  switch (actionType) {
    case ConfigType.ShortMessage: {
      const configs: any[] = [];
      rows.forEach((row) => {
        const [make, serialNumber, deviceCharacterization, fileTypeId] = row.split(',').map((s) => s.trim());
        const transactionId = createUUID();
        configs.push({ transactionId, make, serialNumber, deviceCharacterization, fileTypeId });
      });
      const input: ShortMessagePostRequest = { configs, wakeup: true };
      const errorList = await processAndGetCombinedError(configs, shortMessageRequestConfigAction, parameterType, dispatch);
      const deviceList = errorList?.filter((item: { code: number; }) => item.code === 200);
      if (errorList && errorList?.length > 0) {
        dispatchPopupWithErrorList(input, errorList, actionType, ["make", "serialNumber", "deviceCharacterization", "fileTypeId", "description"], csvShortMessageHeaderString.split(','), dispatch);
      }
      break;
    }
    case ConfigType.ShortCommand: {
      const configs: any[] = [];
      rows.forEach((row) => {
        const [make, serialNumber, deviceCharacterization, fileTypeId, data] = row.split(',').map((s) => s.trim());
        const transactionId = createUUID();
        configs.push({ transactionId, make, serialNumber, deviceCharacterization, fileTypeId, data });
      });
      const input: ShortCommandPostRequest = { configs, wakeup: true };
      const errorList = await processAndGetCombinedError(configs, shortCommandAction, parameterType, dispatch, [], actionType);
      if (errorList && errorList?.length > 0) {
        dispatchPopupWithErrorList(input, errorList, actionType, ["make", "serialNumber", "deviceCharacterization", "fileTypeId", "data", "description"], csvShortCommandHeaderString.split(','), dispatch);
      }
      break;
    }
    case ConfigType.SMHAdjust: {
      const configs: any[] = [];
      rows.forEach((row) => {
        const [make, serialNumber, deviceCharacterization, hoursAdjusted] = row.split(',').map((s) => s.trim());
        configs.push({
          make, serialNumber, deviceCharacterization,
          serviceMeterHourAdjustment: {
            hoursAdjusted: Number.parseInt(hoursAdjusted, 10)
          }
        });
      });
      const input: MeterValueAdjustmentRequest = { configs, wakeup: true };
      const errorList = await dispatch(serviceMeterHourRequestConfigAction(input));
      if (errorList && errorList?.length > 0) {
        dispatchPopupWithErrorList(input, errorList, actionType, ["make", "serialNumber", "deviceCharacterization", "hoursAdjusted", "description"], csvServiceMeterHourString.split(','), dispatch);
      }
      break;
    }
    case ConfigType.DeviceWakeups: {
      const devices: any[] = [];
      rows.forEach((row) => {
        const [deviceId, deviceType] = row.split(',').map((s) => s.trim());
        devices.push({
          deviceId, deviceType
        });
      });
      const input: WakeupRequest = { devices, wakeupType: 'all' };
      const errorList = await processAndGetCombinedError(devices, deviceWakeupsConfigAction, actionType, dispatch);
      if (errorList && errorList?.length > 0) {
        dispatchPopupWithErrorList(input, errorList, actionType, ["deviceId", "deviceType", "description"], csvDeviceWakeupString.split(','), dispatch);
      } else {
        const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Success`;
        displaySuccessMessage('Device Wakeups', uniqueKey, dispatch);
      }
      break;
    }
    case ConfigType.ScheduleCommand: {
    const {
        login: { client, envVariables },
      } = getState();
      const clientAuth: any = client?.authenticate();
      const userId = clientAuth.loginId;
      const configs: any[] = [];
      rows.forEach((row) => {
        const [deviceId, deviceType, data, fileType, frequency, action] = row.split(',').map((s) => s.trim());
        configs.push({ deviceId, deviceType, data, fileType, frequency: Number(frequency),action, userId });
      });
      const input: ScheduleCommandRequest = { configs};
      const errorList = await processAndGetCombinedError(configs, ScheduleCommandAction, parameterType, dispatch, [], actionType);
      if (errorList && errorList?.length > 0) {
        dispatchPopupWithErrorList(input, errorList, actionType, ["deviceId", "deviceType", "data", "fileType", "frequency", "action", "userId"], csvScheduleCommandHeaderString.split(','), dispatch);
      }
      break;
    }
    case ConfigType.ConfigFiles: {
      const configs: any[] = [];
      rows.forEach((row) => {
        const [make, serialNumber, deviceCharacterization, fileTypeId, hash, hexPayload] = row.split(',').map((s) => s.trim());
        const transactionId = createUUID();
        let inputData: any = {};
        if (hash && hexPayload) { // Both value applied with default hash
          inputData = {
            hash,
          }
        } else if ((!hash) && (!hexPayload)) { // Both not available, will throw exception
          inputData = {};
        } else {
          inputData = { // Either hash or configFile
            hash: hexPayload ? undefined : hash,
            configFile: hash ? undefined : hexPayload,
          }
        }
        configs.push({
          transactionId,
          make,
          serialNumber, deviceCharacterization,
          configFile: {
            fileTypeId,
            ...inputData,
          },
        });
      });
      const input: PushConfigFilesRequestBody = { configs, wakeup: true };
      const errorList = await processAndGetCombinedError(configs, configFileRequestAction, parameterType, dispatch);
      if (errorList && errorList?.length > 0) {
        dispatchPopupWithErrorList(input, errorList, actionType, ["make", "serialNumber", "deviceCharacterization", "fileTypeId", "hash", "hexPayload", "description"], csvConfigFileHeaderString.split(','), dispatch);
      }
      break;
    }
    case ConfigType.SetDeviceParameters: {
      switch (parameterType) {
        case DeviceParameterConfigType.EOD: {
          const configs: any[] = [];
          rows.forEach((row) => {
            const [make, serialNumber, deviceCharacterization, endOfDay] = row.split(',').map((s) => s.trim());
            configs.push({
              make, serialNumber, deviceCharacterization,
              endofDayReportTime: {
                endOfDay,
              }
            });
          });
          const input: AssetDeviceConfigRequest = { configs, wakeup: true };
          const errorList = await processAndGetCombinedError(configs, assetDeviceV2RequestAction, parameterType, dispatch);
          if (errorList && errorList?.length > 0) {
            dispatchPopupWithErrorList(input, errorList, parameterType, ["make", "serialNumber", "deviceCharacterization", "endOfDay", "description"], csvDeviceParameter_EOD_String.split(','), dispatch);
          }
          break;
        }
        case DeviceParameterConfigType.TamperResistance: {
          const configs: any[] = [];
          rows.forEach((row) => {
            const [make, serialNumber, deviceCharacterization, machineStartMode, tamperResistance] = row.split(',').map((s) => s.trim());
            configs.push({
              make, serialNumber, deviceCharacterization,
              disableDerate: {
                disableDerateStartMode: {
                  machineStartMode
                },
                disableDerateTamperResistance: {
                  tamperResistance
                }
              }
            });
          });
          const input: AssetDeviceConfigRequest = { configs, wakeup: true };
          const errorList = await processAndGetCombinedError(configs, assetDeviceV2RequestAction, parameterType, dispatch);
          if (errorList && errorList?.length > 0) {
            dispatchPopupWithErrorList(input, errorList, parameterType, ["make", "serialNumber", "deviceCharacterization", "machineStartMode", "tamperResistance", "description"], csvDeviceParameter_TamperResistance_String.split(','), dispatch);
          }
          break;
        }
        default:
      }
      break;
    }
    case ConfigType.Subscription: {
      const configs: any[] = [];
      rows.forEach((row) => {
        const [make, serialNumber, deviceCharacterization, subscriptionId] = row.split(',').map((s) => s.trim());
        configs.push({
          make,
          serialNumber,
          deviceCharacterization: deviceCharacterization === "" ? "master" : deviceCharacterization,
          subscription: {
            subscriptionId: Number.parseInt(subscriptionId, 10),
          }
        });
      });
      const input: SubscriptionConfigRequest = { configs };
      const errorList = await dispatch(subscriptionConfigV2RequestAction(input));
      if (errorList && errorList?.length > 0) {
        dispatchPopupWithErrorList(input, errorList, parameterType, ["make", "serialNumber", "deviceCharacterization", "subscriptionId", "description"], csvSubscription_String.split(','), dispatch);
      }
      break;
    }
    default:
  }
}

export const uploadFireAndForgetCSV =
  (file: any, actionType: string, parameterType: string) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const filetext = await file.text();
    const MAX_ROWS = 25;
    const fileBlob = stringToBlob(filetext, 'text/csv');
    if (!(file?.name.includes('.csv') && fileBlob instanceof Blob)) {
      dispatch(
        enqueueSnackbarAction({
          message: 'Must be a csv file',
          options: { variant: 'error' },
        }),
      );
      return null;
    }
    const delimiter = '\r\n';
    const rawRows = CSVToArray(filetext, delimiter);
    const rowsWithheader = rawRows.filter((row) => !!row.trim())?.filter((row) => !row.startsWith(','));
    if ((rowsWithheader.length === 0) || !((rowsWithheader[0] === getCsvHeaderString(parameterType !== 'Parameter Type' ? parameterType : actionType))
      || (rowsWithheader[0] === `${getCsvHeaderString(parameterType !== 'Parameter Type' ? parameterType : actionType)},Description`))) {
      dispatch(
        enqueueSnackbarAction({
          message: `The CSV file must be valid to ${parameterType !== 'Parameter Type' ? parameterType : actionType} template`,
          options: { variant: 'error' },
        }),
      );
      return null;
    }
    rowsWithheader.shift();
    const rows = rowsWithheader;
    if (rows.length === 0) {
      dispatch(
        enqueueSnackbarAction({
          message: `The CSV file must have minimum 1 row`,
          options: { variant: 'error' },
        }),
      );
      return null;
    }
    if (((actionType === ConfigType.ShortMessage || actionType === ConfigType.ConfigFiles || actionType === ConfigType.DeviceWakeups || actionType === ConfigType.SetDeviceParameters || actionType === ConfigType.ShortCommand || actionType=== ConfigType.ScheduleCommand) && rows.length > 1000) || ((actionType === ConfigType.SMHAdjust || actionType === ConfigType.Subscription) && rows.length > MAX_ROWS)) {
      dispatch(
        enqueueSnackbarAction({
          message: `The CSV file must have maximum 1000 rows`,
          options: { variant: 'error' },
        }),
      );
      return null;
    }
    processFireAndForget(rows, actionType, parameterType, dispatch,getState);
    return null;
  };

export const uploadCampaignFileCSV =
  (file: any, setPercentUploaded: Function, setUploadInProgress: Function) =>
    async (dispatch: AppThunkDispatch, getState: () => AppState) => {
      const {
        login: { client, envVariables },
      } = getState();
      let done = 0;
      let part = 1;
      const campaign = new Campaign(client, envVariables.campaignURL);
      const filetext = await file.text();
      const delimiter = '\r\n';
      const rows = CSVToArray(filetext, delimiter);
      const header = `${rows[0]}${delimiter}`;
      try {
        const chunkSize = 400000 / header.split(',').length;
        const incrament = rows.length / chunkSize > 0 ? (1 / (rows.length / chunkSize)) * 100 : 100;
        const chunkFileSize = 10000000 - header.length; // While javascript characters are 2-bytes, we're sending UTF-8 header by default, so characters transmitted are actually 1-byte.
        const uploadChunk = async (chunk: string) => {
          const formData = new FormData();
          formData.append(
            'fileToUpload',
            stringToBlob(chunk, 'text/csv'),
            `${file.name.toLowerCase().split('.csv')[0]}_Part${part}.csv`,
          );
          const response = await campaign.uploadCampaignCSV(formData);
          done += incrament;
          setPercentUploaded(done);
          return response;
        };
        done += incrament;
        setPercentUploaded(done);
        const promises = [];
        do {
          let chunkRows = 0;
          let characterCount = 0;
          let index = 0;
          while (characterCount < chunkFileSize && index < rows.length) {
            characterCount += rows[index].length + 4;
            chunkRows += 1;
            index += 1;
          }
          if (part === 1) {
            const chunk = rows.splice(0, chunkRows).join(delimiter);
            promises.push(uploadChunk(chunk));
          } else {
            const chunk = `${header}${rows.splice(0, chunkRows).join(delimiter)}`;
            promises.push(uploadChunk(chunk));
          }
          part += 1;
        } while (chunkSize < rows.length);
        await Promise.all(promises);
        dispatch(
          enqueueSnackbarAction({
            message: `${file.name} Uploaded`,
            options: {
              variant: 'success',
            },
          }),
        );
      } catch (error: any) {
        dispatch(
          enqueueSnackbarAction({
            message: error.message,
            options: {
              variant: 'error',
            },
          }),
        );
      } finally {
        setUploadInProgress(false);
      }
    };
export const uploadBlendedFromSearch =
  (selectedDevice: SelectedDevice) =>
    async (dispatch: AppThunkDispatch, getState: () => AppState) => {
      const {
        bulkFlash: { csvDevicesToUpload, manualDevicesToUpload },
      } = getState();
      const deviceList = manualDevicesToUpload
        ? [...manualDevicesToUpload, selectedDevice]
        : [selectedDevice];
      const csvFormatDevices = formatDeviceList(deviceList).join('');
      const finalBlendedFile = `${csvDevicesToUpload || ''}${csvFormatDevices}`;
      dispatch(setCsvDevicesToUpload(finalBlendedFile));
      dispatch(
        preFlashLogs({
          file: finalBlendedFile,
        }),
      );
    };

export const queueAndFlashSoftware =
  ({
    devicesToQueue,
    softwareToQueue,
  }: {
    devicesToQueue: PreFlashRecord[];
    softwareToQueue: {
      fileTypeId: string;
      lastUpdatedBySystem: string;
      id: string;
      partNumber: string;
    };
  }) =>
    async (dispatch: AppThunkDispatch, getState: () => AppState) => {
      const {
        login: { client, envVariables },
      } = getState();
      const { id: hash, fileTypeId, partNumber } = softwareToQueue;
      const clientAuth: any = client?.authenticate();
      const userId = clientAuth.loginId;
      const UUID = createUUID();
      try {
        if (fileTypeId === '10030') {
          const devices = devicesToQueue.map((device) => ({
            deviceKey: device.deviceKey || '',
            tags: ['singleFileConfig'],
          }));
          const deviceDataForQueue: QueueFirmwareRequest = {
            devices,
            hash,
            userId,
            applicationId: softwareToQueue?.lastUpdatedBySystem,
            transactionId: UUID,
          };
          const remoteFlashService = new RemoteFlash(client, envVariables.remoteFlashV1BaseUrl);
          await remoteFlashService.queueFirmware(deviceDataForQueue);
          dispatch(
            enqueueSnackbarAction({
              message: 'Software Queued Successfully',
              options: {
                variant: 'success',
              },
            }),
          );
        } else {
          const devicesFormattedForConfig = devicesToQueue.map((device) => ({
            make: device.make,
            serialNumber: device.deviceType?.endsWith("-Radio") ? undefined : device.serialNumber,
            transactionId: UUID,
            deviceKey: device.deviceKey,
            partNumber,
            tags: fileTypeId === '10330' ? 'singleconfigfile' : 'singleconfigfile',
            configFile: {
              fileTypeId,
              hash,
            },
          }));

          const chunkedDevices: SelectedRowsToWakeup[][] = chunkArray(devicesFormattedForConfig, 5);
          const commands = new ConfigurationFiles(client, envVariables.configurationFilesV1BaseUrl);
          const errorLog: { [key: string]: string }[] = [];
          const emptyConfig = {
            code: "400",
            commercialType: "",
            description: "",
            deviceCharacterization: "",
            deviceId: "",
            deviceKey: "",
            deviceType: "",
            fileTypeId: "",
            hash: "",
            make: "",
            serialNumber: "",
            telematicsAssetId: "",
            transactionId: ""
          }

          const queueDeviceGroup = async (deviceGroup: SelectedRowsToWakeup[]) =>
            new Promise((resolve) => {
              (async () => {
                const input: { configs: any } = {
                  configs: deviceGroup,
                };
                commands.pushConfigFiles(input)
                  .then((response) => {
                    response.data.configs.forEach((config: { code: string }) => {
                      if (config.code !== '200') errorLog.push(config);
                    });
                    return resolve(response.status);
                  })
                  .catch(error => {
                    const errorData = error.response.data;
                    try {
                      errorData.configs.forEach((config: { code: string }) => {
                        errorLog.push(config);
                      });
                    } catch (error) {
                      errorLog.push(emptyConfig);
                    }
                    resolve(false);
                  });
              })();
            });

          const queueDeviceGroups = async (deviceChunks: SelectedRowsToWakeup[][]) =>
            deviceChunks.reduce(
              (accumulatorPromise: any, deviceGroup: SelectedRowsToWakeup[]) =>
                accumulatorPromise.then(() => queueDeviceGroup(deviceGroup)),
              Promise.resolve(),
            );

          await queueDeviceGroups(chunkedDevices);
          const errorLength = errorLog.length;
          if (errorLength > 0) {
            dispatch(
              enqueueSnackbarAction({
                message: `${devicesToQueue.length - errorLength
                  } successful, ${errorLength} unsuccessful queue attempts`,
                options: {
                  persist: true,
                  variant: 'info',
                  downloadMessage: 'Error log:',
                  downloadAction: () => {
                    const rowAsString = errorLog.map(
                      (row: { [key: string]: string }) =>
                        `${queueAndFlashSoftwareAccessors.map(
                          (accessor: string) => `${row[accessor] || ''}`,
                        )}\n`,
                    );
                    const blob = new Blob(
                      [`${queueAndFlashSoftwareHeaderString}${rowAsString.join('')}`],
                      {
                        type: 'text/plain;charset=utf-8',
                      },
                    );
                    FileSaver.saveAs(
                      blob,
                      `Failed_Queue_Log_${moment().format('MMMM_Do_YYYY_h:mm:ss_a')}.csv`,
                    );
                  },
                },
              }),
            );
          } else {
            dispatch(
              enqueueSnackbarAction({
                message: `${fileTypeId} successfully sent to device${devicesToQueue.length > 1 ? 's' : ''
                  }`,
                options: {
                  variant: 'success',
                },
              }),
            );
          }
        }
      } catch (error: any) {
        dispatch(
          enqueueSnackbarAction({
            message: error.message,
            options: {
              variant: 'error',
            },
          }),
        );
      }
    };

export const uploadSoftwareConfigFile =
  ({
    file,
    devicesToQueue,
    fileTypeId,
    tag,
    setPercentUpload,
    finishedCallback,
    onSuccessCallback,
    partNumber,
    overwrite,
  }: {
    file: File;
    devicesToQueue: PreFlashRecord[];
    fileTypeId: string;
    tag: string;
    setPercentUpload: Function;
    finishedCallback: Function;
    onSuccessCallback: Function;
    partNumber?: string;
    overwrite?: boolean;
  }) =>
    async (dispatch: AppThunkDispatch, getState: () => AppState) => {
      const {
        login: { client, envVariables },
      } = getState();
      const clientAuth: any = client?.authenticate();
      const userId = clientAuth.loginId;
      const { storageV1BaseUrl } = envVariables;
      const storage = new FileStorage(client, storageV1BaseUrl);
      const chunks = createChunks(file, 10);
      const numberOfParts = chunks.length;
      const partyNumber = 'CAT';
      const registrationInputs: RegisterArguments = {
        queryParameters: {
          numberOfParts,
          partyNumber,
          fileName: file.name,
          origin: 'iot-gateway',
          ttl: 86400,
          contentType: 'application/bin',
          partNumber,
        },
      };
      try {
        let percentUpload = 10;
        setPercentUpload(percentUpload);
        const {
          data: { uploadUrls, id, uploadId },
        } = await storage.multiPartRegister(registrationInputs);
        const uploadMultiple = () =>
          uploadUrls.map(async (uploadUrl, iterator) => {
            const uploadPercentage = 50 / uploadUrls.length;
            const url = uploadUrl.split('?');
            const parameterString: URLSearchParams | any = new URLSearchParams(url[1]);
            const urlParameters = parametersAsObject(parameterString);
            const request: AxiosRequestConfig = {
              url: url[0],
              params: urlParameters,
              method: 'PUT',
              data: chunks[iterator],
              headers: {
                'Content-Type': 'application/octet-stream',
              },
            };
            const uploadResponse = await Áxios(request);
            percentUpload += uploadPercentage;
            setPercentUpload(percentUpload);
            return uploadResponse;
          });

        await Promise.all(uploadMultiple());

        const completionInput: CompleteUpload = {
          queryParameters: {
            uploadId,
            id,
          },
        };
        const {
          data,
          data: {
            fileName,
            createdBy: { catrecid },
          },
        } = await storage.multiPartCompleteUpload(completionInput);

        percentUpload += 10;
        setPercentUpload(percentUpload);

        if (devicesToQueue.length > 200)
          dispatch(
            enqueueSnackbarAction({
              message: `Queue will be going on in the background you will be notified when complete`,
              options: { variant: 'info' },
            }),
          );

        const parameters = new URLSearchParams();
        parameters.append('fileId', data.id);
        parameters.append(
          'metadata',
          JSON.stringify({
            isRetrievable: false,
            fileTypeId,
            fileName,
            userId: catrecid,
            applicationId: 'iot-gateway',
            partNumber,
          }),
        );
        parameters.append('overwrite', `${overwrite}`);
        const configure = new ConfigurationFilesLibrary(
          client,
          envVariables.configurationFilesLibraryV1BaseUrl,
        );

        const configureResponse = await configure.uploadConfigFilesFromStorage(parameters);
        percentUpload += 10;
        setPercentUpload(percentUpload);
        if (fileTypeId === '10030') {
          const devices = devicesToQueue.map((device) => ({
            deviceKey: device.deviceKey || '',
            tags: [tag],
          }));
          const deviceDataForQueue: QueueFirmwareRequest = {
            devices,
            hash: configureResponse.data.id,
            userId,
          };

          const remoteFlashService = new RemoteFlash(client, envVariables.remoteFlashV1BaseUrl);
          const remoteFlashResponse = await remoteFlashService.queueFirmware(deviceDataForQueue);
          percentUpload += 10;
          setPercentUpload(percentUpload);
          setPercentUpload(100);
          if (remoteFlashResponse.status === 200 || remoteFlashResponse.status === 201) {
            setPercentUpload(0);
            dispatch(
              enqueueSnackbarAction({
                message: 'Software Queued Successfully',
                options: {
                  variant: 'success',
                },
              }),
            );
            dispatch({
              type: RemoteFlashActionNames.SET_FILE_EXISTS_IN_DB,
              payload: false,
            });
            onSuccessCallback();
          }
        } else {
          const UUID = createUUID();
          const devicesFormattedForConfig = devicesToQueue.map((device) => ({
            make: device.make,
            serialNumber: device.serialNumber,
            transactionId: UUID,
            deviceKey: device.deviceKey,
            tags: [tag],
            configFile: {
              fileTypeId,
              hash: configureResponse.data.id,
            },
          }));

          const chunkedDevices: SelectedRowsToWakeup[][] = chunkArray(devicesFormattedForConfig, 5);
          const commands = new ConfigurationFiles(client, envVariables.configurationFilesV1BaseUrl);
          const errorLog: { [key: string]: string }[] = [];
          const newUploadPercentage = (100 - percentUpload) / chunkedDevices.length;

          const queueDeviceGroup = async (deviceGroup: SelectedRowsToWakeup[]) =>
            new Promise((resolve) => {
              (async () => {
                try {
                  const input: { configs: any } = {
                    configs: deviceGroup,
                  };
                  const response = await commands.pushConfigFiles(input);
                  response.data.configs.forEach((config: { code: string }) => {
                    if (config.code !== '200') errorLog.push(config);
                  });
                  resolve(response.status);
                } catch (error) {
                  resolve(false);
                }
              })();
            });

          const queueDeviceGroups = async (deviceChunks: SelectedRowsToWakeup[][]) =>
            deviceChunks.reduce(
              (accumulatorPromise: any, deviceGroup: SelectedRowsToWakeup[]) =>
                accumulatorPromise.then(() => {
                  percentUpload += newUploadPercentage;
                  setPercentUpload(percentUpload);
                  return queueDeviceGroup(deviceGroup);
                }),
              Promise.resolve(),
            );

          await queueDeviceGroups(chunkedDevices);

          const errorLength = errorLog.length;
          if (errorLength > 0) {
            dispatch(
              enqueueSnackbarAction({
                message: `${devicesToQueue.length - errorLength
                  } successful, ${errorLength} unsuccessful queue attempts`,
                options: {
                  variant: 'info',
                  persist: true,
                  downloadMessage: 'Error log:',
                  downloadAction: () => {
                    const headerString = `Make, Serial Number, TransactionId, Code, Description, Device Characterization, Device Id, Device Key, Device Type, File Type Id, Hash, Telematics Asset Id,\n`;
                    const accessors = [
                      'make',
                      'serialNumber',
                      'transactionId',
                      'code',
                      'description',
                      'deviceCharacterization',
                      'deviceId',
                      'deviceKey',
                      'deviceType',
                      'fileTypeId',
                      'hash',
                      'telematicsAssetId',
                    ];
                    const rowAsString = errorLog.map(
                      (row: { [key: string]: string }) =>
                        `${accessors.map((accessor: string) => `${row[accessor] || ''}`)}\n`,
                    );
                    const blob = new Blob([`${headerString}${rowAsString.join('')}`], {
                      type: 'text/plain;charset=utf-8',
                    });
                    FileSaver.saveAs(
                      blob,
                      `Failed_Queue_Log_${moment().format('MMMM_Do_YYYY_h:mm:ss_a')}.csv`,
                    );
                  },
                },
              }),
            );
          } else {
            dispatch(
              enqueueSnackbarAction({
                message: `${fileTypeId} successfully sent to device${devicesToQueue.length > 1 ? 's' : ''
                  }`,
                options: {
                  variant: 'success',
                },
              }),
            );
            onSuccessCallback();
          }
        }
      } catch (error: any) {
        setPercentUpload(0);
        let message = 'File already exists in the database';
        if (error.response.status === 409) {
          const hashId = error?.response?.data?.id;
          dispatch({
            type: RemoteFlashActionNames.SET_FILE_EXISTS_IN_DB,
            payload: true,
          });
          if (hashId) {
            dispatch({
              type: RemoteFlashActionNames.SET_HASH_EXISTS_IN_DB,
              payload: hashId,
            });
          }
          return;
        }
        if (error.response.status === 403) {
          message = 'Permission Denied';
        } else if (error.response.status === 500) {
          message = 'Internal server error';
        }
        dispatch(
          enqueueSnackbarAction({
            message,
            options: {
              key: (Date.now() + Math.random()).toString(),
              variant: 'error',
            },
          }),
        );
      }
      finishedCallback();
    };

export const uploadSoftwareConfigExistingFile =
  ({
    hash,
    devicesToQueue,
    fileTypeId,
    tag,
    setPercentUpload,
    finishedCallback,
    onSuccessCallback,
  }: {
    hash: string;
    devicesToQueue: PreFlashRecord[];
    fileTypeId: string;
    tag: string;
    setPercentUpload: Function;
    finishedCallback: Function;
    onSuccessCallback: Function;
  }) =>
    async (dispatch: AppThunkDispatch, getState: () => AppState) => {
      const {
        login: { client, envVariables },
      } = getState();
      const clientAuth: any = client?.authenticate();
      const userId = clientAuth.loginId;
      try {
        if (fileTypeId === '10030') {
          const devices = devicesToQueue.map((device) => ({
            deviceKey: device.deviceKey || '',
            tags: [tag],
          }));
          const deviceDataForQueue: QueueFirmwareRequest = {
            devices,
            hash,
            userId,
          };
          const remoteFlashService = new RemoteFlash(client, envVariables.remoteFlashV1BaseUrl);
          const remoteFlashResponse = await remoteFlashService.queueFirmware(deviceDataForQueue);
          if (remoteFlashResponse.status === 200 || remoteFlashResponse.status === 201) {
            setPercentUpload(0);
            dispatch(
              enqueueSnackbarAction({
                message: 'Software Queued Successfully',
                options: {
                  variant: 'success',
                },
              }),
            );
            dispatch({
              type: RemoteFlashActionNames.SET_FILE_EXISTS_IN_DB,
              payload: false,
            });
            onSuccessCallback();
          }
        } else {
          const UUID = createUUID();
          const devicesFormattedForConfig = devicesToQueue.map((device) => ({
            make: device.make,
            serialNumber: device.serialNumber,
            transactionId: UUID,
            deviceKey: device.deviceKey,
            tags: [tag],
            configFile: {
              fileTypeId,
              hash,
            },
          }));

          const chunkedDevices: SelectedRowsToWakeup[][] = chunkArray(devicesFormattedForConfig, 5);
          const commands = new ConfigurationFiles(client, envVariables.configurationFilesV1BaseUrl);
          const errorLog: { [key: string]: string }[] = [];

          const queueDeviceGroup = async (deviceGroup: SelectedRowsToWakeup[]) =>
            new Promise((resolve) => {
              (async () => {
                try {
                  const input: { configs: any } = {
                    configs: deviceGroup,
                  };
                  const response = await commands.pushConfigFiles(input);
                  response.data.configs.forEach((config: { code: string }) => {
                    if (config.code !== '200') errorLog.push(config);
                  });
                  resolve(response.status);
                } catch (error) {
                  resolve(false);
                }
              })();
            });

          const queueDeviceGroups = async (deviceChunks: SelectedRowsToWakeup[][]) =>
            deviceChunks.reduce(
              (accumulatorPromise: any, deviceGroup: SelectedRowsToWakeup[]) =>
                accumulatorPromise.then(() => queueDeviceGroup(deviceGroup)),
              Promise.resolve(),
            );

          await queueDeviceGroups(chunkedDevices);

          const errorLength = errorLog.length;
          if (errorLength > 0) {
            dispatch(
              enqueueSnackbarAction({
                message: `${devicesToQueue.length - errorLength
                  } successful, ${errorLength} unsuccessful queue attempts`,
                options: {
                  variant: 'info',
                  persist: true,
                  downloadMessage: 'Error log:',
                  downloadAction: () => {
                    const headerString = `Make, Serial Number, TransactionId, Code, Description, Device Characterization, Device Id, Device Key, Device Type, File Type Id, Hash, Telematics Asset Id,\n`;
                    const accessors = [
                      'make',
                      'serialNumber',
                      'transactionId',
                      'code',
                      'description',
                      'deviceCharacterization',
                      'deviceId',
                      'deviceKey',
                      'deviceType',
                      'fileTypeId',
                      'hash',
                      'telematicsAssetId',
                    ];
                    const rowAsString = errorLog.map(
                      (row: { [key: string]: string }) =>
                        `${accessors.map((accessor: string) => `${row[accessor] || ''}`)}\n`,
                    );
                    const blob = new Blob([`${headerString}${rowAsString.join('')}`], {
                      type: 'text/plain;charset=utf-8',
                    });
                    FileSaver.saveAs(
                      blob,
                      `Failed_Queue_Log_${moment().format('MMMM_Do_YYYY_h:mm:ss_a')}.csv`,
                    );
                  },
                },
              }),
            );
          } else {
            dispatch(
              enqueueSnackbarAction({
                message: `${fileTypeId} successfully sent to device${devicesToQueue.length > 1 ? 's' : ''
                  }`,
                options: {
                  variant: 'success',
                },
              }),
            );
            onSuccessCallback();
          }
        }
      } catch (error: any) {
        setPercentUpload(0);
        let message = 'File already exists in the database';
        if (error.response.status === 409) {
          dispatch({
            type: RemoteFlashActionNames.SET_FILE_EXISTS_IN_DB,
            payload: true,
          });
          return;
        }
        if (error.response.status === 403) {
          message = 'Permission Denied';
        } else if (error.response.status === 500) {
          message = 'Internal server error';
        }
        dispatch(
          enqueueSnackbarAction({
            message,
            options: {
              key: (Date.now() + Math.random()).toString(),
              variant: 'error',
            },
          }),
        );
      }
      finishedCallback();
    };

export const wakeUpDevices =
  (selectedDevices: SelectedRowsToWakeup[]) =>
    async (dispatch: AppThunkDispatch, getState: () => AppState) => {
      const {
        login: { client, envVariables },
      } = getState();
      const clientAuth: any = client?.authenticate();
      const devices = new Devices(client, envVariables.deviceApiV2BaseUrl);
      const userId = clientAuth.loginId;
      const wakeupRequest: WakeupRequest = {
        devices: [],
        wakeupType: 'all',
        carrier: 'ALL',
        userId,
        applicationId: 'iot-gateway',
      };
      const deviceWakeUps = new DeviceWakeUps(client, envVariables.deviceWakeUpsV2);
      const errorLog: { [key: string]: string }[] = [];
      async function wakeDeviceGroup(deviceGroup: SelectedRowsToWakeup[]) {
        return new Promise((resolve) => {
          (async () => {
            try {
              const wakeUpGroup = { ...wakeupRequest, devices: deviceGroup.map((device) => ({ deviceKey: device.deviceKey })) };
              const bypassHeliosWakeup = false;
              const uploadResponse = await deviceWakeUps.wakeupDevices(
                wakeUpGroup,
                bypassHeliosWakeup,
              );
              uploadResponse.data.devices.forEach((device: any) => {
                if (device.code !== '200') {
                  errorLog.push({ device, description: 'Request failed with status code 404' });
                }
              });
              resolve(uploadResponse.status);
            } catch (error: any) {
              if (error?.response?.data?.devices)
                error.response.data.devices.forEach((device: any) => {
                  errorLog.push({ device, description: error.message });
                });
              resolve(false);
            }
          })();
        });
      }
      const chunkedDevices: SelectedRowsToWakeup[][] = chunkArray(selectedDevices, 25);

      const wakeUpDeviceGroups = async (deviceChunks: SelectedRowsToWakeup[][]) =>
        deviceChunks.reduce(
          (accumulatorPromise: any, deviceGroup: SelectedRowsToWakeup[]) =>
            accumulatorPromise.then(() => wakeDeviceGroup(deviceGroup)),
          Promise.resolve(),
        );
      try {
        await wakeUpDeviceGroups(chunkedDevices);
      } catch (error: any) {
        dispatch(
          enqueueSnackbarAction({
            message: error.message,
            options: {
              variant: 'error',
            },
          }),
        );
      }
      const errorLength = errorLog.length;
      const numberSuccessful = selectedDevices.length - errorLength;
      const message = `${numberSuccessful > 0 ? `${selectedDevices.length - errorLength} successful,` : ``
        } ${errorLength} unsuccessful wakeup${errorLength > 1 ? `s` : ``}`;
      const variant = numberSuccessful > 0 ? 'info' : 'error';
      if (errorLength > 0) {
        dispatch(
          enqueueSnackbarAction({
            message,
            options: {
              variant,
              persist: true,
              downloadMessage: 'Error log:',
              downloadAction: () => {
                const headerString = `Make, Serial Number, TransactionId, Code, Description, DeviceCharacterization,\n`;
                const accessors = [
                  'make',
                  'serialNumber',
                  'transactionId',
                  'code',
                  'description',
                  'deviceCharacterization',
                ];
                const rowAsString = errorLog.map(
                  (row: { [key: string]: any }) =>
                    `${accessors.map((accessor: string) => `${row.device[accessor] || ''}`)}\n`,
                );
                const blob = new Blob([`${headerString}${rowAsString.join('')}`], {
                  type: 'text/plain;charset=utf-8',
                });
                FileSaver.saveAs(
                  blob,
                  `Failed_Wakeup_Log_${moment().format('MMMM_Do_YYYY_h:mm:ss_a')}.csv`,
                );
              },
            },
          }),
        );
      } else {
        dispatch(
          enqueueSnackbarAction({
            message: `Wakeup successfully sent to device${selectedDevices.length > 1 ? 's' : ''}`,
            options: {
              variant: 'success',
            },
          }),
        );
      }
    };

export const removeSelectedFromList =
  (selectedRows: PreFlashRecord[]) => (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      bulkFlash: { csvDevicesToUpload },
    } = getState();
    if (csvDevicesToUpload) {
      const toRemoveDeviceIds = new Set(
        formatDeviceList(selectedRows).map((item) => item.split(',')[2]?.trim()),
      );
      const savedCSVArray = csvDevicesToUpload.split(`\n`);
      const deviceArrayWithRemovals = savedCSVArray.filter(
        (item) => !(toRemoveDeviceIds.has(item.split(',')[2]?.trim()) || item.length < 1),
      );
      dispatch({
        type: BulkFlashLogActionNames.SET_CSV_TO_UPLOAD,
        payload: deviceArrayWithRemovals.join('\n'),
      });

      if (deviceArrayWithRemovals.length === 0) {
        dispatch({
          type: BulkFlashLogActionNames.SET_TOTAL_ACCEPTED_DEVICES,
          payload: 0,
        });
        dispatch({
          type: BulkFlashLogActionNames.SET_PRE_FLASH_LOG,
          payload: undefined,
        });
      }
      dispatch(preFlashLogs({}));
    }
  };

export const removeAllDevices = () => (dispatch: AppThunkDispatch) => {
  dispatch({
    type: BulkFlashLogActionNames.SET_TOTAL_ACCEPTED_DEVICES,
    payload: undefined,
  });
  dispatch({
    type: BulkFlashLogActionNames.SET_PRE_FLASH_LOG,
    payload: undefined,
  });
  dispatch({
    type: BulkFlashLogActionNames.SET_POST_FLASH_LOG,
    payload: undefined,
  });
  dispatch({
    type: BulkFlashLogActionNames.SET_CSV_TO_UPLOAD,
    payload: null,
  });
};

export const savePreFlashFilter =
  (filterUpdate: PreFlashFilters) =>
    async (dispatch: AppThunkDispatch, getState: () => AppState) => {
      const {
        bulkFlash: { preFlashFilters },
      } = getState();
      const key = `${Object.keys(filterUpdate)}`;
      const payload = { ...preFlashFilters, ...filterUpdate };
      if (filterUpdate[key].length === 0) delete payload[key];
      dispatch({
        type: BulkFlashLogActionNames.SET_ACTIVE_FILTERS,
        payload,
      });
    };

export const clearAllPreFlashFilter = () => (dispatch: AppThunkDispatch) => {
  dispatch({
    type: BulkFlashLogActionNames.SET_ACTIVE_FILTERS,
    payload: {},
  });
};

export const exportPostFlash = () => async (_: any, getState: () => AppState) => {
  const {
    bulkFlash: { postFlashLogs: postFlash },
  } = getState();

  if (postFlash) {
    const rowAsString = postFlash.map(
      (row: any) => `${postAccessors.map((accessor: string) => `${row[accessor] || ''}`)}\n`,
    );
    const blob = new Blob([`${postHeaderString}\n${rowAsString.join('')}`], {
      type: 'text/plain;charset=utf-8',
    });
    FileSaver.saveAs(blob, `Post_Flash_Log_${moment().format('MMMM_Do_YYYY_h:mm:ss_a')}.csv`);
  }
};


export const fetchCommandAction = (input: Array<any>, headerElement: Array<any>) =>
  async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const homing = new Homing(client, envVariables.homingV2BaseUrl);
    let errorList: any[] = [];
    try {
      let response: any;
      if (headerElement.includes("Device-Characterization")) {
        response = await homing.bulkGetAssetMakeSerailNumberAndDeviceChar(input);
      } else {
        response = await homing.bulkGetAssetMakeAndSerailNumber(input);
      }
      if (response.status === 200) {
        errorList = response?.data.filter((item: { code: number; }) => item.code !== 200);
        if (errorList.length === 0) {
          const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Success`;
          displaySuccessMessage('PendingCommandResponse', uniqueKey, dispatch);
          return response?.data;
        }
        return response?.data;
      }
    } catch (error: any) {
      errorList = input.map(config => ({ ...config, description: error.message }));
      const uniqueKey = `${moment().seconds(0).milliseconds(0)}_Error`;
      displayErrorMessage(error.toString(), uniqueKey, dispatch);
    }
    return errorList;
  };

const generateErrorReportFetchCommand = async (payload: Array<any>, errorList: Array<any>, expectKeys: Array<string>, csvHeader: Array<string>, fileName: string, dispatch: AppThunkDispatch) => {
  const solidError: Array<string> = [];
  errorList.forEach((error) => {
    const errorRow: Array<any> = [];
    expectKeys.forEach((key) => {
      if (error[key]) {
        errorRow.push(error[key]);
      } else {
        const currentRecord = payload.find(item => item.assetSerialNumber === error.asset.assetSerialNumber);
        if (currentRecord) {
          errorRow.push(currentRecord[key]);

        } else {
          errorRow.push(' ');
        }
      }
    });

    const slicedAsset = errorRow.slice(0, 1);
    errorRow.shift();
    errorRow.shift();
    solidError.push(`${slicedAsset[0]?.assetMake},${slicedAsset[0]?.assetSerialNumber},${errorRow.join(',')}`);
  });
  const blob = new Blob(
    [`${csvHeader.concat('Description').join(',')}\n${solidError.join('\n')}`],
    {
      type: 'text/plain;charset=utf-8',
    },
  );
  await FileSaver.saveAs(blob, `Failed_${fileName}_Queue_Log_${moment().format('MMMM_Do_YYYY_h:mm:ss_a')}.csv`);
  await delay(500);
  dispatch(
    enqueueSnackbarAction({
      message: 'Downloaded',
      options: { key: (Date.now() + Math.random()).toString(), variant: 'success' },
    }),
  );
}

const dispatchPopupWithErrorListFetchCommand = (payload: any, errorList: any[], actionType: string, expectKeys: string[], csvHeader: string[], dispatch: AppThunkDispatch) => {
  dispatch(
    enqueueSnackbarAction({
      message: `${errorList.length} devices returned errors`,
      options: {
        variant: 'error',
        downloadAction: () => {
          generateErrorReportFetchCommand(payload, errorList, expectKeys, csvHeader, actionType, dispatch);
        },
      },
    }),
  );
}

export const uploadCommandsInfoCSV =
  (file: any, startTime: string | undefined, endTime: string | undefined,) => async (dispatch: AppThunkDispatch) => {
    const filetext = await file.text();
    const MAX_ROWS = 26;
    const fileBlob = stringToBlob(filetext, 'text/csv');
    const actionType = "fetchCommand";
    if (!(file?.name.includes('.csv') && fileBlob instanceof Blob)) {
      dispatch(
        enqueueSnackbarAction({
          message: 'Must be a csv file',
          options: { variant: 'error' },
        }),
      );
      return null;
    }
    const delimiter = '\r\n';
    const rawRows = CSVToArray(filetext, delimiter);
    const rowsWithheader = rawRows.filter((row) => !!row.trim())?.filter((row) => !row.startsWith(','));
    if ((rowsWithheader.length === 0)) {
      dispatch(
        enqueueSnackbarAction({
          message: `The CSV file must be valid to template`,
          options: { variant: 'error' },
        }),
      );
      return null;
    }
    const header = rowsWithheader.slice(0, 1);
    delete rowsWithheader[0];

    const rows = rowsWithheader;
    if (rows.length === 0) {
      dispatch(
        enqueueSnackbarAction({
          message: `The CSV file must have minimum 1 row`,
          options: { variant: 'error' },
        }),
      );
      return null;
    }
    if ((actionType === "fetchCommand") && rows.length > 1000) {
      dispatch(
        enqueueSnackbarAction({
          message: `The CSV file must have maximum 1000 rows`,
          options: { variant: 'error' },
        }),
      );
      return null;
    }
    const configs: any[] = [];
    let input: any;
    let errorList;
    let deviceList;
    let deviceKeyList;
    let errorL;
    const headerElement = header[0].split(",");

    rows.forEach((row) => {
      if (headerElement.includes("Device-Characterization")) {
        const [assetMake, assetSerialNumber, deviceCharacterization] = row.split(',').map((s) => s.trim());
        configs.push({
          assetMake,
          assetSerialNumber, deviceCharacterization
        });
        const inputWithDevice: Array<DeviceByMakeSerialAndDeviceCharBulkGetRequest> = configs;
        input = inputWithDevice;
      } else {
        const [assetMake, assetSerialNumber] = row.split(',').map((s) => s.trim());
        configs.push({
          assetMake,
          assetSerialNumber
        });
        const inputs: Array<DeviceByMakeAndSerialBulkGetRequest> = configs;
        input = inputs;
      }
    });

    if (headerElement.includes("Device-Characterization")) {
      errorL = await processAndGetCombinedError(configs, fetchCommandAction, "fetchCommand", dispatch, headerElement);
      errorList = errorL?.filter((item: { code: number; }) => item.code !== 200);
      deviceList = errorL?.filter((item: { code: number; }) => item.code === 200);
      deviceKeyList = deviceList.map((item: { device: { deviceKey: any; }; }) =>
        item?.device?.deviceKey
      )
      if (errorList && errorList?.length > 0) {
        dispatchPopupWithErrorListFetchCommand(input, errorList, "fetchCommand", ["asset", "serialNumber", "deviceCharacterization", "description"], csvCommandsInfo.split(','), dispatch);
      }
    } else {
      errorL = await processAndGetCombinedError(configs, fetchCommandAction, "fetchCommand", dispatch, headerElement);
      errorList = errorL?.filter((item: { code: number; }) => item.code !== 200);
      deviceList = errorL?.filter((item: { code: number; }) => item.code === 200);
      deviceKeyList = deviceList.map((item: { device: { deviceKey: any; }; }) =>
        item.device?.deviceKey
      );
      if (errorList && errorList?.length > 0) {
        dispatchPopupWithErrorListFetchCommand(input, errorList, "fetchCommand", ["asset", "serialNumber", "description"], csvCommandsInfoAssetNSerailNumber.split(','), dispatch);
      }
    }

    const commandRequest: any[] = [];
    let commandBulkInput: Array<GetAllCommandsByDeviceKeyRequest> = [];
    deviceKeyList.forEach((dvcKey: string) => {
      const requestCommand: GetAllCommandsByDeviceKeyRequest = { deviceKey: dvcKey, startTime, endTime, statuses: '1' };
      commandRequest.push(requestCommand);
    });

    commandBulkInput = commandRequest;
    dispatch(getCommandsFromMultipleDevices(commandBulkInput, true));
    return { deviceKeyList, errorList };
  };

const generateErrorReportModemFlash = async (errorList: Array<any>, fileName: string, dispatch: AppThunkDispatch) => {
  const solidError: Array<string> = [];
  const expectKeys = ["deviceId", "code", "description"];
  errorList.forEach((error) => {
    const errorRow: Array<string> = [];
    expectKeys.forEach((key) => {
      if (error[key]) {
        errorRow.push(error[key]);
      }
    });
    solidError.push(`${errorRow.join(',')}`);
  });
  const blob = new Blob(
    [`${["Device Id,Code,Description"].join(',')}\n${solidError.join('\n')}`],
    {
      type: 'text/plain;charset=utf-8',
    },
  );
  await FileSaver.saveAs(blob, `Failed_${fileName}_Queue_Log_${moment().format('MMMM_Do_YYYY_h:mm:ss_a')}.csv`);
  await delay(500);
  dispatch(
    enqueueSnackbarAction({
      message: 'Downloaded',
      options: { key: (Date.now() + Math.random()).toString(), variant: 'success' },
    }),
  );

}

export const uploadModemFlash = (file: File, item: any) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
  const {
    login: { client, envVariables },
  } = getState();
  const flashLog = new FlashLog(client, envVariables.modemFlashFirmwareURL);
  const clientAuth: any = client?.authenticate();
  const filetext = await file.text();
  const MAX_ROWS = 2000;
  const fileBlob = stringToBlob(filetext, 'text/csv');
  if (!(file?.name.includes('.csv') && fileBlob instanceof Blob)) {
    dispatch(
      enqueueSnackbarAction({
        message: 'Must be a csv file',
        options: { variant: 'error' },
      }),
    );
    return null;
  }
  const delimiter = '\r\n';
  const rawRows = CSVToArray(filetext, delimiter);
  const rowsWithheader = rawRows.filter((row) => !!row.trim())?.filter((row) => !row.startsWith(','));
  if ((rowsWithheader.length === 0) || !((rowsWithheader[0] === csvModemOnlyFlash))) {
    dispatch(
      enqueueSnackbarAction({
        message: `The CSV file must be valid`,
        options: { variant: 'error' },
      }),
    );
    return null;
  }
  rowsWithheader.shift();
  const rows = rowsWithheader;
  if (rows.length === 0) {
    dispatch(
      enqueueSnackbarAction({
        message: `The CSV file must have minimum 1 row`,
        options: { variant: 'error' },
      }),
    );
    return null;
  }
  if (rows.length > MAX_ROWS) {
    dispatch(
      enqueueSnackbarAction({
        message: `The CSV file must have maximum 2000 rows`,
        options: { variant: 'error' },
      }),
    );
    return null;
  }
  dispatch({
    type: BulkFlashLogActionNames.SET_MODEM_FLASH_FILE,
    payload: file,
  });
  try {
    const devices: any[] = [];
    rows.forEach((row) => {
      const [deviceId] = row.split(',').map((s) => s.trim());
      devices.push({ deviceId });
    });
    const transactionId = createUUID();
    const userId = clientAuth.loginId;
    const input: modemOnlyFlashRequset = { devices, hash:item.id, transactionId, userId, wakeup: false, };
    const response = await flashLog.queueModemFirmware(input);
    const logs = response.data.modemFirmware;
    const successfulLogs = logs.filter(
      (results: ModemFlashRecord) => results.description === 'Success',
    );
    const failedLogs = logs
      .filter((results: ModemFlashRecord) => results.description !== 'Success');
    if (failedLogs.length > 0) {
      dispatch(
        enqueueSnackbarAction({
          message: `${failedLogs.length} devices returned errors`,
          options: {
            variant: 'error',
            downloadAction: () => {
              generateErrorReportModemFlash(failedLogs, file.name, dispatch);
            },
          },
        }),
      );
    }
    dispatch({
      type: BulkFlashLogActionNames.SET_MODEM_FLASH_LOG,
      payload: successfulLogs,
    });
    if (successfulLogs.length > 0 && failedLogs.length === 0) {
      dispatch(
        enqueueSnackbarAction({
          message: 'Modem Flash Queued Successfully',
          options: {
            variant: 'success',
          },
        }),
      );
    } else if (failedLogs.length === 0 && successfulLogs.length === 0) {
      dispatch(
        enqueueSnackbarAction({
          message: 'Upload failed. Please try with different devices',
          options: { variant: 'error' },
        }),
      );
    }

  } catch (error: any) {
    if (error?.response?.status === 400) {
      dispatch(
        enqueueSnackbarAction({
          message: `${error.message}`,
          options: {
            variant: 'error',
          },
        }),
      );
    } else {
      dispatch(
        enqueueSnackbarAction({
          message: 'Failed To Queue',
          options: {
            variant: 'error',
          },
        }),
      );
    }
  }
  return '';
};

export const modemFlashStatus = (file: File) => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
  const {
    login: { client, envVariables },
  } = getState();
  const flashLog = new FlashLog(client, envVariables.modemFlashFirmwareURL);
  const filetext = await file.text();
  const MAX_ROWS = 2000;
  const fileBlob = stringToBlob(filetext, 'text/csv');
  if (!(file?.name.includes('.csv') && fileBlob instanceof Blob)) {
    dispatch(
      enqueueSnackbarAction({
        message: 'Must be a csv file',
        options: { variant: 'error' },
      }),
    );
    return null;
  }
  const delimiter = '\r\n';
  const rawRows = CSVToArray(filetext, delimiter);
  const rowsWithheader = rawRows.filter((row) => !!row.trim())?.filter((row) => !row.startsWith(','));
  if ((rowsWithheader.length === 0) || !((rowsWithheader[0] === csvModemOnlyFlash))) {
    dispatch(
      enqueueSnackbarAction({
        message: `The CSV file must be valid`,
        options: { variant: 'error' },
      }),
    );
    return null;
  }
  rowsWithheader.shift();
  const rows = rowsWithheader;
  if (rows.length === 0) {
    dispatch(
      enqueueSnackbarAction({
        message: `The CSV file must have minimum 1 row`,
        options: { variant: 'error' },
      }),
    );
    return null;
  }
  dispatch({
    type: BulkFlashLogActionNames.SET_MODEM_FLASH_FILE,
    payload: file,
  });
  if (rows.length > MAX_ROWS) {
    dispatch(
      enqueueSnackbarAction({
        message: `The CSV file must have maximum 2000 rows`,
        options: { variant: 'error' },
      }),
    );
    return null;
  }
  try {
    const devices: any[] = [];
    rows.forEach((row) => {
      const [deviceId] = row.split(',').map((s) => s.trim());
      devices.push({ deviceId });
    });
    const input = { devices };
    const result = await flashLog.modemFirmwareStatus(input);
    const logs = result.data.modemFirmware;
    const successfulLogs = logs.filter(
      (results: ModemFlashRecord) => results?.status,
    );
    dispatch({
      type: BulkFlashLogActionNames.SET_MODEM_FLASH_LOG,
      payload: successfulLogs,
    });
    dispatch(
      enqueueSnackbarAction({
        message: `Get ${file.name} Status Successfully`,
        options: {
          variant: 'success',
        },
      }),
    );
  } catch (error: any) {
    dispatch(
      enqueueSnackbarAction({
        message: 'Failed To Upload',
        options: {
          variant: 'error',
        },
      }),
    );
  }
  return null;
};

export const refreshModemFlash = () => async (dispatch: AppThunkDispatch, getState: () => AppState) => {
  const {
    login: { client, envVariables }, bulkFlash: { modemFlashRecord },
  } = getState();
  const flashLog = new FlashLog(client, envVariables.modemFlashFirmwareURL);
  try {
    if (modemFlashRecord && modemFlashRecord.length > 0) {
      const deviceList =
        modemFlashRecord.map((row) => {
          const { deviceKey } = row;
          const input = {
            deviceKey
          };
          return input;
        });
      const input: any = { devices: deviceList };
      const result = await flashLog.modemFirmwareStatus(input);
      const deviceArray = result.data.modemFirmware;
      dispatch({
        type: BulkFlashLogActionNames.SET_MODEM_FLASH_LOG,
        payload: deviceArray,
      });
      dispatch(
        enqueueSnackbarAction({
          message: 'Modem Flash Status Refreshed',
          options: {
            variant: 'success',
          },
        }),
      );
    }
  } catch (error: any) {
    dispatch(
      enqueueSnackbarAction({
        message: 'Failed To Refresh Status',
        options: {
          variant: 'error',
        },
      }),
    );
  }
  return null;
};